/**
* 基础菜单 财务管理 入驻协议
*/
<template>
  <div class="contianer">
    <!-- 面包屑导航 -->
    <div class="address">
        <div class="tions">
          <p class="title f20 color409EFF fontWeight mb20">入驻协议信息</p>
          <div class="billing_information">
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">销售商名称(乙方)</p>
                <span class="f14 color333">{{tableData.seller_name}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">联系人</p>
                <span class="f14 color333">{{tableData.contact_name	}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">联系电话</p>
                <span class="f14 color333">{{tableData.contact_tel}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">电子邮箱</p>
                <span class="f14 color333">{{tableData.contact_email}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">省份</p>
                <span class="f14 color333">{{tableData.province_name}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">城市</p>
                <span class="f14 color333">{{tableData.city_name}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">详细地址</p>
                <span class="f14 color333">{{tableData.mailing_address}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">协议有效期起始时间</p>
                <span class="f14 color333">{{tableData.expire_start_date}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">签约时间</p>
                <span class="f14 color333">{{tableData.signing_time}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">协议有效期结束时间</p>
                <span class="f14 color333">{{tableData.expire_end_date}}</span>
              </div>
            </div>
            <div class="flex_box">
              <div class="flex_box billing_item">
                <p class="label f14 color666">平台手续费</p>
                <span class="f14 color333">{{tableData.service_fee_rate}}</span>
              </div>
              <div class="flex_box billing_item">
                <p class="label f14 color666">入驻协议名称</p>
                <span class="f14 color333"><el-link type="primary" @click="openPdf(tableData.url)">{{tableData.entry_agreement_name}}</el-link></span>
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</template>


<script>
  import {
    sellerAgreement
  } from '../../api/basisMG'

  export default {
    data: () => {
      return {
        loading: false, //是显示加载
        tableData: {},
      }
    },
    // 注册组件
    components: {
    },

    /**
     * 创建完毕
     */
    created() {
        this.getdata()
    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      openPdf(url){
        window.open(url)
      },
      // 获取公司列表
      getdata(parameter) {
        this.loading = true
        sellerAgreement()
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.tableData = res.content;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.order_code == cell.innerText || row.mobile == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      },
    }
  }
</script>


<style scoped>
  .contianer {
    height: calc(100% - 60px);
    background: #fff;
    padding: 20px;
    border-radius: 8px;
  }

  /deep/ .textarea .el-textarea__inner {
    height: 120px;
    width: 320px;
    resize: none;
  }

  /deep/ .addressForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }
  /deep/ .addressForm .el-input--small {
    width: 320px;
  }

   .mt20 {
     margin-top: 20px;
   }

  .f20 {
    font-size: 20px;
  }

  .fontWeight {
    font-weight: 600;
  }

  .flex_box {
    display: flex;
  }

  .flex_box {
    display: flex;
  }

  .billing_item {
    border-bottom: 1px solid #EBEEF5;
  }

  .billing_item span {
    height: 40px;
    padding-left: 12px;
    padding-right: 15px;
    width: 300px;
    display: flex;
    align-items: center;
    overflow: hidden;
  }

  .copy {
    width: 20px;
    height: 20px;
  }

  .copy img {
    width: 20px;
    height: 20px;
  }

  .saleTitle {
    color: #333333;
    font-size: 20px;
    font-weight: 600;
    margin-bottom: 12px;
    margin-top: 25px;
  }

  .picTitle {
    color: #333333;
    font-size: 15px;
    font-weight: 400;
    margin: 20px 0;
  }

  /deep/ .delivery .el-form-item {
    margin-left: 25%;
  }
  .breadcrumb {
    margin-bottom: 15px;
  }

  .address {
    width: 500px;
    height: 168px;
    margin: 30px 0 0 36px;
  }
  .ment {
    padding: 2px 12px;
    justify-content: space-between;
  }
  .text {
    font-family: 'PingFang SC';
    font-style: normal;
    line-height: 28px;
    color: #409EFF;
  }

  .color409EFF {
    color: #409eff;
  }

  .color333 {
    color: #333333;
  }

  .color666 {
    color: #666666;
  }

  .fontWeight {
    font-weight: 600;
  }

  .tions {
    width: 50%;
  }

  .tions span {
    width: 400px;
  }

  /deep/ .tions .el-descriptions__header {
    border-bottom: 1px solid #f4f4f4;
    padding: 14px 20px;
  }

  /deep/ .tions .el-descriptions__body {
    padding: 0 20px;
  }

  /deep/ .el-descriptions .is-bordered .el-descriptions-item__cell {
    border: 0 !important;
    border-bottom: 1px solid #F5F7FA !important;
  }

  .label {
    width: 150px;
    height: 40px;
    line-height: 40px;
    background: #F5F7FA;
    padding-left: 12px;
  }

</style>





// WEBPACK FOOTER //
// src/views/finance/Agreement.vue